import { router } from "expo-router";
import { Platform, Pressable, ScrollView, Text, View } from "react-native";

import { COLORS, FONTS } from "../../../lib/brand";
import { PANE_THEMES } from "../../../components/brand/paneThemes";

const STUDENT_THEME = PANE_THEMES.Student;

import { StudentPortalShell } from "../../../components/student/StudentPortalShell";
import { useStudentPortalShellData } from "../../../lib/useStudentPortalShellData";


// TODO(qbo): Replace this stub once the QBO Contractor Payments
// integration ships. The real flow will:
//   1. Pull a W-9 collection link via the QBO API
//   2. Open it in a new tab / iframe
//   3. Webhook back when complete and bump
//      prize_disbursements.tax_info_status to 'received'
// For now we just tell the student we're handling it manually.
export default function StudentTaxInfoStubScreen() {
  const shell = useStudentPortalShellData();
  return (
    <StudentPortalShell
      topbarTitle="Tax info"
      topbarFirstName={shell.topbarFirstName}
      avatarName={shell.avatarName}
      avatarUrl={shell.avatarUrl}
      identity={shell.identity}
      casesBadgeCount={shell.casesBadgeCount}
      hideSidebar
    >
      <ScrollView style={{ flex: 1, backgroundColor: COLORS.OFFW.hex }} contentContainerStyle={{ paddingBottom: 64 }}>
        <View style={{ paddingHorizontal: 22, paddingTop: 28, maxWidth: 640 }}>
          <Pressable
            onPress={() => router.replace("/student/winnings")}
            style={Platform.OS === "web" ? ({ cursor: "pointer" } as const) : null}
          >
            <Text
              style={{
                fontFamily: FONTS.bodyMedium,
                fontSize: 11.5,
                letterSpacing: 1.2,
                textTransform: "uppercase",
                color: STUDENT_THEME.textOnSurfaceDim,
              }}
            >
              ← Winnings
            </Text>
          </Pressable>

          <Text
            style={{
              marginTop: 18,
              fontFamily: FONTS.bodyBold,
              fontSize: 9.5,
              letterSpacing: 1.8,
              textTransform: "uppercase",
              color: COLORS.AMBER.hex,
            }}
          >
            Tax info collection
          </Text>
          <Text style={{ marginTop: 6, fontFamily: FONTS.display, fontSize: 32, lineHeight: 36, color: COLORS.FOREST.hex }}>
            We're finalizing this — promise it'll be quick
          </Text>
          <Text
            style={{
              marginTop: 12,
              fontFamily: FONTS.body,
              fontSize: 14,
              lineHeight: 22,
              color: STUDENT_THEME.textOnSurfaceDim,
            }}
          >
            We're hooking up automated W-9 collection right now. While that ships, Tyler will reach
            out within 24 hours with the link by email. Sorry for the extra step — we'll have it
            automated soon.
          </Text>

          <View
            style={{
              marginTop: 22,
              paddingHorizontal: 18,
              paddingVertical: 16,
              borderRadius: 6,
              backgroundColor: STUDENT_THEME.surfaceRaisedBg,
              borderWidth: 1,
              borderColor: STUDENT_THEME.border,
            }}
          >
            <Text style={{ fontFamily: FONTS.bodyBold, fontSize: 9.5, letterSpacing: 1.6, textTransform: "uppercase", color: STUDENT_THEME.textOnSurfaceDim }}>
              What to expect
            </Text>
            <Text style={{ marginTop: 8, fontFamily: FONTS.body, fontSize: 13, lineHeight: 20, color: COLORS.FOREST.hex }}>
              {
                "1. Tyler emails you a secure W-9 link\n2. You fill out + sign electronically (~2 minutes)\n3. We process payment within ~3 business days"
              }
            </Text>
          </View>

          <Text
            style={{
              marginTop: 18,
              fontFamily: FONTS.body,
              fontSize: 12,
              color: STUDENT_THEME.textOnSurfaceDim,
            }}
          >
            Questions? Reach out to <Text style={{ color: COLORS.AMBER.hex }}>luke@coravu.com</Text>.
          </Text>
        </View>
      </ScrollView>
    </StudentPortalShell>
  );
}
